import React, { Component } from 'react';
import { Flex, Button, Modal, List } from 'antd-mobile';
import sensors from 'sa-sdk-javascript';
import { getQueryVariable, AppList, getArray2Name, getProxyConfig } from '@/utils/utils';
import { ApiContactVerify } from '@/api/index';
const Alert = Modal.alert;

class ContactVerification extends Component {
  constructor(props) {
    super(props);

    // 当前app，用该参数来区分对应app 借以区分不同的ip地址 默认都是kashway
    let localApp = (props.match.params.app || 'kashway').toLowerCase();
    let app = getArray2Name(AppList, localApp);
    if (!app) {
      app = AppList[3]; // 默认是kashway
    }

    this.state = {
      localApp,
      appRules: app, // 当前app相关配置
      // 监控相关
      monitorData: {
        h5_agree_click: 0, // 点击按钮埋点
        h5_download_click: 0, // 下载按钮埋点相关
      },
      canClickAgree: true,
      name: '',
      mobile: '',
      code: '',
      modalShow: false,
    }
  };
  onAgree = ()=> {
    this.setMonitorData('h5_agree_click');
    if (!this.state.canClickAgree) return
    this.setState({ canClickAgree: false })

    this.agreeProxy();
  }

  agreeProxy () {
    let { code, mobile, localApp } = this.state;
    const { header } = this.state.appRules;

    ApiContactVerify({
      method: 'get',
      headers: header,
      data: {
        code,
        mobile
      },
      ...getProxyConfig(localApp),
    }).then(()=>{
      this.setState({
        modalShow: true,
      })
      // this.showModal();
    }).finally(()=>{
      this.setState({
        canClickAgree: true
      })
    })
  }
  /**
   * 该方法已弃用，因为控制不了对应className
   * 虽然可以解决掉componentWillReceiveProps的问题
   */
  showModal () {
    // 直接使用Modal去修改对应visible会报错 因为React在16后会移除componentWillReceiveProps方法
    // 报错内容: Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code.
    // https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html
    // 解决方案: npx react-codemod rename-unsafe-lifecycles
    Alert('Verification Success!', 
      <div>
        <h2>Verification Success!</h2>
        <p>You can download the app and <br/> enjoy the quick loan service</p>
      </div>,
      [
      { text: 'Download', onPress: () => this.onModalClose() },
    ])
  }
  onModalClose () {
    this.setState({ modalShow: false, })
  }

  onDownLoad () {
    this.setMonitorData('h5_download_click');
    window.open(this.state.appRules.download, 'target');
    this.onModalClose();
  }

  setMonitorData = (key)=> {
    let old = this.state.monitorData;
    let o = {};
    o[key] = old[key] + 1;
    this.setState({ monitorData: Object.assign(old, o) });
    sensors.setProfile(this.state.monitorData);
  }
  // 数据打点相关
  sensorsInit () {
    sensors.init({
      server_url: process.env.NODE_ENV === 'production' ? 
        'https://salasa.xcreditech.com/sa?project=production' : 'https://salasa.xcreditech.com/sa',
      heatmap: {
        clickmap: 'default',
        scroll_notice_map: 'default'
      },
      show_log: process.env.NODE_ENV === 'development', // 仅本地测试需要开启log
    });
    sensors.quick('autoTrack');
  }
  userinfoInit () {
    this.setState({
      name: getQueryVariable('name'),
      mobile: getQueryVariable('mobile'),
      code: getQueryVariable('code'),
    })
  }
  componentDidMount() {
    this.userinfoInit();
    this.sensorsInit();
  }

  render() {
    let { canClickAgree } = this.state;
    let { termsOfUse, privacyPolicy } = this.state.appRules;
    let { localApp, name, modalShow } = this.state;
    // 默认是印度kashway 切换app可变化为对应app
    // 处理文字很长的情况
    let mainClassName = 'content-box contact-verification '+ localApp;
    let dialogClassName = 'am-modal__contactVerification '+ localApp;
    let absClassName = 'invitation-box_abs';
    let hasLine3 = name.length > 45;
    // 一行大约24个
    if (hasLine3) {
      absClassName += ' line-3';
    }
    return <Flex direction='column' className={mainClassName}>
      <Modal
        className={dialogClassName}
        visible={ modalShow }
        transparent
        closable={true}
        maskClosable={false}
        onClose={() => this.onModalClose() }
        title="Verification Success!"
        footer={[{ text: 'Download Now', onPress: () => { this.onDownLoad() } }]}
        afterClose={() => {  }}
      >
        <h2>Verification Success!</h2>
        <p>You can download the app and <br/> enjoy the quick loan service.</p>
      </Modal>

      <Flex.Item className='content-content-body'>
        <List className='am-list__invitation'>
          <img src={ window.$localCdnLink + '/svg/agree.svg' } alt='MIB' />
          <div className='invitation-box'>
            <p>I agree to be</p>
            <p className={absClassName}>
              <span className='invitation-box_abs-names'>
                { name }’s
              </span>
              {/* <span className='invitation-box_abs-unit'>'S</span> */}
            </p>
            <p>emergency contact</p>
          </div>
          {/* <p>I agree to be<br/> { this.state.name }'s <br/>emergency contact</p> */}
        </List>
        <List className='am-list__submit'>
          <Button type="primary"
            disabled={ !canClickAgree }
            loading={ !canClickAgree }
            onClick={()=> this.onAgree() }
          >
            I Agree
          </Button>
        </List>
        <List className='am-list__agree'>
          <a href={termsOfUse} target='_blank' rel="noopener noreferrer">
            Terms of Use
          </a>
          <span>and</span>
          <a href={privacyPolicy} target='_blank' rel="noopener noreferrer">
            Privacy Policy
          </a>
        </List>
      </Flex.Item>
    </Flex>
  }
}

export default ContactVerification;
